import Vue from 'vue';

Vue.filter('timeFormat', require('./format').default);
